import React from "react";
import { Coffee, Clock } from "lucide-react";
import PhoneShell from "../components/PhoneShell";

/**
 * Friendly "this café is offline" screen shown when the tenant is
 * hard-locked (e.g. unpaid subscription). We intentionally do NOT reveal
 * billing details to protect the café's reputation with its customers.
 */
const Unavailable = () => (
    <PhoneShell>
        <div
            className="flex flex-col items-center justify-center px-8 py-16 min-h-screen text-center"
            data-testid="unavailable-screen"
        >
            <div className="h-20 w-20 rounded-full bg-[#F5E9D6] flex items-center justify-center mb-6">
                <Coffee className="h-10 w-10 text-[#2C1A12]" strokeWidth={1.8} />
            </div>
            <h1 className="font-display font-black text-3xl text-[#2C1A12] leading-tight">
                We're not taking orders right now
            </h1>
            <p className="mt-4 text-[#6B5A52] text-base leading-relaxed max-w-xs">
                This café is temporarily unavailable. Please check back a bit later or
                pop in to order at the counter.
            </p>
            <div className="mt-8 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#8C7A72] font-bold">
                <Clock className="h-3 w-3" strokeWidth={2.5} />
                Try again soon
            </div>
            <div className="mt-10 flex flex-col gap-3 w-full max-w-xs">
                <a href="/me" data-testid="unavailable-my-cafes" className="rounded-full bg-[#2C1A12] text-white px-6 py-3 text-sm font-display font-bold active:scale-95 transition-transform">
                    See my other cafés
                </a>
                <a href="/" data-testid="unavailable-home" className="rounded-full bg-white border border-[#E8DCCB] px-6 py-3 text-sm font-display font-bold active:scale-95 transition-transform">
                    Coffeein7 home
                </a>
            </div>
        </div>
    </PhoneShell>
);

export default Unavailable;
